<template>
    <div class="row">
        <div class="col-md-12">
            <KTCodePreview v-bind:title="'Jenis Komponen'" >
                <template v-slot:toolbar>
                    <ButtonComponent name="tambah" :Title="'Tambah'" v-b-modal.modal @click.native="openModal('Tambah')"></ButtonComponent>
                </template>
               <template v-slot:body>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="jenis_komponen" :search="search">
                        <template v-slot:item.action="{ item }">
                            <ButtonComponent name="edit" v-b-modal.modal @click.native="openModal('Edit',item)"></ButtonComponent>
                            <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)" dataTitleTooltip="Hapus" /> 
                        </template>
                    </v-data-table>
               </template>
            </KTCodePreview>
            <b-modal @ok="onSubmit" no-enforce-focus ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" id="modal" :title="`${statusModal} Kecabangan`">
                <b-form>
                    <b-form-group label="Komponen">
                        <b-form-input type="text" required v-model="request.komponen"
                            placeholder="Masukkan Komponen"></b-form-input>
                    </b-form-group>

                    <b-form-group label="Bobot">
                        <b-form-input type="text" required v-model="request.bobot"
                            placeholder="Masukkan Bobot"></b-form-input>
                    </b-form-group>
                </b-form>
                <template #modal-footer="{ ok, cancel }">
                    <!-- Emulate built in modal footer ok and cancel button actions -->
                    <b-button size="sm" variant="primary" @click="ok()" >
                    Simpan
                    </b-button>
                    <b-button size="sm" variant="danger" @click="cancel()">
                    Batal
                    </b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import KTCodePreview from "@/view/content/CardContent.vue";
    import ButtonComponent from '@/view/content/components/button/buttonComponent.vue';
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import axios from "axios";

    export default{

        data(){
            return {
                headers : [
                    {text : "No"        , value : "no"},
                    {text : 'Komponen'  , value : 'komponen'},
                    {text : 'Bobot'     , value : 'bobot'},
                    {text : 'Aksi'      , value : 'action' }

                ],

                jenis_komponen : [],
                statusModal : '',
                request : {
                    key         : null,
                    komponen    : null,
                    bobot       : null
                }
            }
        },

        components : {
            KTCodePreview,
            ButtonComponent
        },
        async mounted(){
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Master" },
                { title: "Master Jenis Komponen" },
            ]),

            this.getData()
        },

        methods : {
            async getData(){
                try{

                    if(this.jenis_komponen.length > 0){
                        this.jenis_komponen = [];
                    }

                    await axios.get('master/jenis-komponen').then(response => {
                        if(response.status == 200){
                            response.data.data.some( (e,index) => {
                                var object = {
                                    no          : index + 1,
                                    key         : e.key,
                                    komponen    : e.komponen,
                                    bobot       : e.bobot
                                }

                                this.jenis_komponen.push(object);
                                return index > e.length;
                            })
                        }
                    })

                }catch(err){
                    this.$swal('Failed');
                }
            },

            async store(form){
                try{

                    const formData = {
                        komponen : form.komponen,
                        bobot    : form.bobot
                    };

                    const result = await axios.post('master/jenis-komponen/save',formData);
                    this.refreshData(result,'Store');

                }catch(err){
                    this.$swal(`Failed`);
                }
            },

            async update(form){
                try{

                    const formData = {
                        key         : form.key,
                        komponen    : form.komponen,
                        bobot       : form.bobot
                    }

                    const result = await axios.put(`master/jenis-komponen/update/${form.key}`,formData);
                    this.refreshData(result,'Update');

                }catch(err){
                    this.$swal(`Failed`);
                }
            },

            refreshData(result,alert){
                if(result.data.meta.code == 200){
                    this.$swal(`Success ${alert} Data`)
                    this.getData();
                }else{
                    this.$swal(`Failed`);
                }   
            },

            async openModal(status, itemData = null ){
                this.statusModal = status;

                this.request = {
                    key        : null,
                    komponen    : null,
                    bobot       : null
                }

                if(status == 'Edit'){
                    this.request.key        = itemData.key;
                    this.request.komponen   = itemData.komponen;
                    this.request.bobot      = itemData.bobot;
                }


            },

            async onSubmit(){
                const form = this.request;

                if(form.key === null){
                    this.store(form);
                }else{
                    this.update(form);
                }
            },

            async deleteData(key) {
        try {
            this.$swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover this item!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
            }).then(async (result) => {
            if (result.value) {
                // User confirmed, so delete the item
                const result = await axios.delete(`master/jenis-komponen/delete/${key}/`)
                
                this.refreshData(result, 'Delete')
            } else {
                // User canceled, so do nothing
            }
            })
        } catch (err) {
            this.$swal(`Failed`);
        }
    },
        }
    }

</script>